// Inside the iOS/Android app (Capacitor shell in mobile/): the native side keeps the session alive in the background,
// shows it on the lock screen / in the notification and passes hardware talk keys (headset, Bluetooth, volume keys).
// In the browser everything here is a no-op.

const cap = window.Capacitor;
export const APP = !!cap?.isNativePlatform?.() && !!cap?.isPluginAvailable?.('TalkNative');
export const APP_PLATFORM = APP ? cap.getPlatform() : null;
if (APP && document.documentElement) document.documentElement.classList.add('in-app', `app-${APP_PLATFORM}`);

const call = (method, opts = {}) => (APP ? cap.nativePromise('TalkNative', method, opts) : Promise.resolve(null));

export const native = {
  info: () => call('info'),
  /** session joined (microphone already granted) */
  start: (opts) => call('start', opts),
  update: (opts) => call('update', opts),
  stop: () => call('stop'),
  /** fn({ action: 'down'|'up'|'toggle', source }) → remove function */
  onPtt(fn) {
    if (!APP) return () => {};
    const id = cap.nativeCallback('TalkNative', 'addListener', { eventName: 'ptt' }, (ev) => ev && fn(ev));
    return () => Promise.resolve(id).then((callbackId) => cap.nativePromise('TalkNative', 'removeListener', { callbackId, eventName: 'ptt' })).catch(() => {});
  },
};

/** the app's own start page (server choice, mobile/www/index.html) */
export function chooseServer() {
  const home = cap.getServerUrl?.() || (APP_PLATFORM === 'ios' ? 'capacitor://localhost' : 'https://localhost');
  location.href = `${home.replace(/\/$/, '')}/index.html?change`;
}

/** app settings on this device */
export const appPrefs = {
  get handsFree() {
    return localStorage.getItem('talk.app.handsFree') === '1';
  },
  set handsFree(v) {
    localStorage.setItem('talk.app.handsFree', v ? '1' : '');
  },
  get volumeKeys() {
    return localStorage.getItem('talk.app.volumeKeys') === '1';
  },
  set volumeKeys(v) {
    localStorage.setItem('talk.app.volumeKeys', v ? '1' : '');
  },
};
